module.exports = __webpack_public_path__ + "img/IMG_0057_L_Black.eb0b94ac.jpg";